<div class="mt-6 p-3 flex-1 bg-gray-50">
    <ng-container *ngIf="tieneConceptos; else sinConceptos">
        <div class="overflow-x-auto">
            <table class="w-full max-w-[80%] mx-auto  text-xs divide-y divide-gray-200">
                <thead class="bg-gray-200 border-b border-gray-200 sticky top-0 z-10">
                    <tr>
                        <th class="h-8 px-2 text-left font-medium text-gray-600 w-[180px]">Totales</th>
                        <th class="h-8 px-2 text-right font-medium text-gray-600 w-[180px]">% Imp.</th>
                        <th class="h-8 px-2 text-right font-medium text-gray-600 w-[180px]">Importe</th> 
                        <th class="h-8 px-2 text-left font-medium text-gray-600 w-[120px]">Provincia</th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-100">
                    <!-- Subtotal Exento -->
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 py-1.5 font-medium text-gray-700">Sub Total Exento</td>
                        <td class="px-2 py-1.5 text-right text-gray-600"></td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.subtotalExento ?? 0) | currency:'ARS':'' }}
                        </td> 
                        <td class="px-2 py-1.5"></td>
                    </tr>

                    <!-- Subtotal Gravado -->
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 py-1.5 font-medium text-gray-700">Sub Total Gravado</td>
                        <td class="px-2 py-1.5 text-right text-gray-600"></td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.subtotalGravado ?? 0) | currency:'ARS':'' }}
                        </td> 
                        <td class="px-2 py-1.5"></td>
                    </tr>

                    <!-- Percep. IVA -->
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 py-1.5 font-medium text-gray-700">Percepción IVA</td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.porcentajePercepcionIVA ?? 0) | number:'1.2-2' }}
                        </td>
                        <td class="px-2 py-1.5">
                            <input type="number"
                                class="w-full text-right px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                                [(ngModel)]="datosFacturas.formulario.totales.importePercepcionIVA"
                                (ngModelChange)="validarTotal()" 
                                min="0" 
                                max="99999999999999.9999"/>
                        </td> 
                        <td class="px-2 py-1.5"></td>
                    </tr>

                    <!-- Percep. IB -->
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 py-1.5 font-medium text-gray-700">Percepción IB</td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.porcentajePercepcionIB ?? 0) | number:'1.2-2' }}
                        </td>
                        <td class="px-2 py-1.5">
                            <input type="number"
                                class="w-full text-right px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                                [(ngModel)]="datosFacturas.formulario.totales.importePercepcionIB"
                                (ngModelChange)="validarTotal()" 
                                min="0" 
                                max="99999999999999.9999"/>
                        </td> 
                        <td class="px-2 py-1.5">
                            <select
                                class="w-full px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                                [(ngModel)]="datosFacturas.formulario.totales.provinciaPercepcionIB" #selectProvinciaIB>
                                <option value="" class="text-gray-500">Seleccionar</option>
                                @for (provincia of provincias; track provincia.CODI) {
                                <option [value]="provincia.CODI">{{ provincia.NOMBRE }}</option>
                                }
                            </select>
                        </td>
                    </tr>

                    <!-- Percep. IB 2 -->
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 py-1.5 font-medium text-gray-700">Percepción IB 2</td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.porcentajePercepcionIB2 ?? 0) | number:'1.2-2' }}
                        </td>
                        <td class="px-2 py-1.5">
                            <input type="number"
                                class="w-full text-right px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                                [(ngModel)]="datosFacturas.formulario.totales.importePercepcionIB2"
                                (ngModelChange)="validarTotal()" 
                                min="0" 
                                max="99999999999999.9999"/>
                        </td> 
                        <td class="px-2 py-1.5">
                            <select
                                class="w-full px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                                [(ngModel)]="datosFacturas.formulario.totales.provinciaPercepcionIB2"
                                #selectProvinciaIB2>
                                <option value="" class="text-gray-500">Seleccionar</option>
                                @for (provincia of provincias; track provincia.CODI) {
                                <option [value]="provincia.CODI">{{ provincia.NOMBRE }}</option>
                                }
                            </select>
                        </td>
                    </tr>

                    <!-- Percep. Ganancias -->
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 py-1.5 font-medium text-gray-700">Percepción Ganancias</td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.porcentajePercepcionGcias ?? 0) | number:'1.2-2' }}
                        </td>
                        <td class="px-2 py-1.5">
                            <input type="number"
                                class="w-full text-right px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                                [(ngModel)]="datosFacturas.formulario.totales.importePercepcionGcias"
                                (ngModelChange)="validarTotal()" 
                                min="0" 
                                max="99999999999999.9999"/>
                        </td> 
                        <td class="px-2 py-1.5"></td>
                    </tr>

                    <!-- IVA1 -->
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 py-1.5 font-medium text-gray-700">IVA 1</td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.iva1.porcentaje ?? 0) | number:'1.2-2' }}
                        </td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.iva1.importe ?? 0) | currency:'ARS':'' }}
                        </td> 
                        <td class="px-2 py-1.5"></td>
                    </tr>

                    <!-- IVA2 -->
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 py-1.5 font-medium text-gray-700">IVA 2</td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.iva2.porcentaje ?? 0) | number:'1.2-2' }}
                        </td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.iva2.importe ?? 0) | currency:'ARS':'' }}
                        </td> 
                        <td class="px-2 py-1.5"></td>
                    </tr>

                    <!-- IVA3 -->
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 py-1.5 font-medium text-gray-700">IVA 3</td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.iva3.porcentaje ?? 0) | number:'1.2-2' }}
                        </td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.iva3.importe ?? 0) | currency:'ARS':'' }}
                        </td> 
                        <td class="px-2 py-1.5"></td>
                    </tr>

                    <!-- IVA4 -->
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 py-1.5 font-medium text-gray-700">IVA 4</td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.iva4.porcentaje ?? 0) | number:'1.2-2' }}
                        </td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.iva4.importe ?? 0) | currency:'ARS':'' }}
                        </td> 
                        <td class="px-2 py-1.5"></td>
                    </tr>

                    <!-- Impuestos Internos -->
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 py-1.5 font-medium text-gray-700">Impuestos Internos</td>
                        <td class="px-2 py-1.5 text-right text-gray-900">
                            {{ (datosFacturas.formulario.totales.porcentajeImpuestosInternos ?? 0) | number:'1.2-2' }}
                        </td>
                        <td class="px-2 py-1.5">
                            <input type="number"
                                class="w-full text-right px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                                [(ngModel)]="datosFacturas.formulario.totales.importeImpuestosInternos"
                                (ngModelChange)="validarTotal()" min="0" 
                                 max="99999999999999.9999"
                                />
                        </td> 
                        <td class="px-2 py-1.5"></td>
                    </tr>

                    <!-- Total -->
                    <tr class="bg-gray-200 font-medium text-gray-900">
                        <td class="px-2 py-2">TOTAL</td>
                        <td class="px-2 py-2 text-right"></td>
                        <td class="px-2 py-2 text-right">
                            {{moneda}}
                            {{ (datosFacturas.formulario.totales.total ?? 0) | currency:'ARS':'' }}
                        </td> 
                        <td class="px-2 py-2"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>

    <ng-template #sinConceptos>
        <div class="p-4 text-center">
            <p class="text-gray-500">
                No hay conceptos seleccionados para esta factura.
            </p>
        </div>
    </ng-template>
</div>